import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { BotgroupPage } from './botgroup.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'botgroup',
        component: BotgroupPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [BotgroupPage],
    exports: [BotgroupPage]
})
export class BotgroupPageModule {}
